
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const CaretDownIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M53.6041 69.197C50.7995 72.9343 45.1985 72.9343 42.3938 69.197L21.4113 41.2366C17.949 36.6229 21.2196 30 27.0164 30L68.9815 30C74.7784 30 78.049 36.623 74.5867 41.2366L53.6041 69.197ZM48 65L68.9815 37H27L48 65Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M50.8048 67.0962C49.4002 68.9679 46.5979 68.9679 45.1933 67.0962L24.2107 39.1358C22.4699 36.8161 24.1208 33.5 27.0165 33.5L68.9816 33.5C71.8772 33.5 73.5281 36.8161 71.7873 39.1358L50.8048 67.0962Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M53.6041 69.197C50.7995 72.9343 45.1985 72.9343 42.3938 69.197L21.4113 41.2366C17.949 36.6229 21.2196 30 27.0164 30L68.9815 30C74.7784 30 78.049 36.623 74.5867 41.2366L53.6041 69.197ZM48 65L68.9815 37H27L48 65Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M50.8048 67.0962C49.4002 68.9679 46.5979 68.9679 45.1933 67.0962L24.2107 39.1358C22.4699 36.8161 24.1208 33.5 27.0165 33.5L68.9816 33.5C71.8772 33.5 73.5281 36.8161 71.7873 39.1358L50.8048 67.0962Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
